<template>    
	<div>
	<main class="main-wrapper flex-grow-1 with-footer">
		<!-- <div class="t-headline11 t-color-headlineBlack pda-16 t-center font-m">전체 강의</div> -->
 <div ref="examHeader">
		<view-header :todayDate="todayDate" :endDate="endDate" :paperData="paperData"></view-header>
	</div>
		<div class="divider"></div>
		<!-- subtabs -->
		<view-tab @setViewTab="setViewTab" :setTabFixed="setTabFixed"></view-tab>
		<div class="container container--narrow pdt-30">
			<div class="mgb-24" v-if="campaignData">
				<a class="d-block" v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank">
					<img :src="campaignData.image" alt="" v-if="campaignData.image" />
				</a>
				<a class="d-block" v-else href="javascript:void(0)" style="cursor:none">
						<img :src="campaignData.image" alt="">
					</a>
				</div>
				<component 
					:is="tabType"
					:periodPolicy="periodPolicy"
					:summary="summary"
					:pointPolicy="pointPolicy"
					:badges="badges"
				></component>
		</div>
</main>
<transition name="fade" mode="out-in" v-if="screenTypeName != 'IndependentExamTotalView'">
	<view-footer
		:paperData="paperData"
		:setTabFixed="setTabFixed"
	></view-footer>
</transition>
	</div>
	
</template>

<script>
/**
 * 단독 전체 시험 결과 상세 메인 컴포넌트(independent total exam view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import campaignApi from '@/api/campaignApi.js'
import ViewHeader from './view/Header'
import ViewFooter from './view/Footer'
import ViewTab from './view/ViewTab'
import ViewInformation from './view/Information'
import ViewReward from './view/Reward'

export default {
	data() {
		return {
			paperData: null,
			tabType: 'Information',
			setTabFixed: false,

			periodPolicy: null,
			summary: '',
			pointPolicy: null,
			badges: null,
			campaignData: null,
			screenTypeName: null,
			todayDate: null,
			endDate:null
		}
	},
	components: {
		'view-header': ViewHeader,
		'view-footer': ViewFooter,
		'view-tab': ViewTab,
		'Information': ViewInformation,
		'Reward': ViewReward,
	},

	mounted() {
		let params = {
			distId: this.$route.params.distId
		}

		// get exam view information
		examApi.guestExamOnlineView(params).then((response) => {
			this.paperData = response.data.data
			this.periodPolicy = this.paperData.period
			this.summary =  this.paperData.summary
			this.pointPolicy = this.paperData.point
			this.todayDate = new Date();
			this.endDate = new Date(this.$moment(this.periodPolicy.application.end).format('YYYY-MM-DD HH:mm:ss'))
		})

		// get exam badge list
		examApi.guestExamOnlineViewBadges(params).then((response) => {
			this.badges = response.data.data
		})

		// get campaign data
		campaignApi.campaign({locationType: 'IN_INDEPENDENT_EXAM', locationValue: this.$route.params.distId}).then((response) => {
			this.campaignData = response.data.data
		}).catch((err) => {})

	},

	methods: {
		setViewTab(tabType) {
			this.tabType = tabType
		},
		
		// 상하 스크롤 이동시 탭 고정(move up/down scroll fixed tab)
		scrollMove(el) {
			if (parseInt(el.scrollTop) >= parseInt(this.$refs.examHeader.offsetHeight)) {
				this.setTabFixed = true
			}else {
				this.setTabFixed = false
			}
		},
	},
	updated(){
		this.screenTypeName = this.$route.name;
	}

}
</script>